<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall" :initial-values="{expiresIndays: '',expiresInhours : '',expiresInminutes : ''}">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Device ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="deviceId"
                                  rules="required"
                                  :class="(errors.deviceId && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="deviceId"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Serial ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="serialId"
                                  rules="required"
                                  :class="(errors.serialId && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="serialId"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3">
                        <Button class="btn btn-primary mr-1" :loading="loader">Create</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'pos' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'POS'},
        {name: 'Add'},
      ],
      loader: false,
      // status: false,

    }
  },
  methods: {
    sendCall(values) {
      let data = values
      return
      this.loader = true
      this.makeRequest('post', 'v1/add-merchant-staff', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'merchant-staff'});
          }
        }

      });

    },
  },
}
</script>

